import React from "react";
import type {VoidFunctionComponent} from "react";
import '../../styles/common/font-icon.scss';

export interface IFontIcon {
  ariaLabel?: string;
  title?: string;
  icon: Icon;
  additionalClassName?: string;
}

export const iconValues = [
  "icon-angle-down",
  "icon-angle-left",
  "icon-angle-right",
  "icon-angle-up",
  "icon-arrow-left",
  "icon-arrow-right",
  "icon-arrow-down",
  "icon-arrow-up",
  "icon-bootcamp",
  "icon-cable-connector",
  "icon-check",
  "icon-courses",
  "icon-dashboard",
  "icon-difficulty-advanced",
  "icon-difficulty-all-compact",
  "icon-difficulty-intermediate-compact",
  "icon-difficulty-rookie-compact",
  "icon-edit-oval",
  "icon-exclamation-triangle",
  "icon-eye",
  "icon-eye-slash",
  "icon-facebook-f",
  "icon-favorite-solid",
  "icon-favorite",
  "icon-filter-solid",
  "icon-filter",
  "icon-hand-left-solid-with-keys",
  "icon-hand-left-solid",
  "icon-hand-left",
  "icon-hand-right-solid-with-keys",
  "icon-hand-right-solid",
  "icon-hand-right",
  "icon-hands-both",
  "icon-info",
  "icon-instagram",
  "icon-jump-backward",
  "icon-jump-forward",
  "icon-keyboard-octave-middle",
  "icon-keyboard-octave-top",
  "icon-microphone-slash",
  "icon-microphone",
  "icon-minus",
  "icon-multiply",
  "icon-new-music",
  "icon-note-close",
  "icon-note-correct",
  "icon-note-incorrect",
  "icon-order-any",
  "icon-order-difficulty",
  "icon-order-key-signature",
  "icon-order-sequential",
  "icon-pause",
  "icon-pinterest-p",
  "icon-play",
  "icon-plus-oval",
  "icon-plus",
  "icon-repeat",
  "icon-search",
  "icon-settings",
  "icon-sliders-h",
  "icon-songs",
  "icon-star",
  "icon-stop",
  "icon-tachometer-alt",
  "icon-tempo-solid",
  "icon-tempo",
  "icon-twitter",
  "icon-type-notation",
  "icon-type-video-and-notation",
  "icon-video-tutorial-solid",
  "icon-youtube",
] as const;

export type Icon = typeof iconValues[number];

export function isIcon(value: unknown): value is Icon {
  return typeof value === "string" && (iconValues as readonly string[]).includes(value as string);
}

export const FontIcon: VoidFunctionComponent<IFontIcon> = ({
  icon,
  ariaLabel,
  title,
  additionalClassName,
}) => {
  const className = icon;
  const ariaLabelText = ariaLabel ? `${ariaLabel}` : '';
  return (
    <div className="font-icon-container" role="img" aria-label={ariaLabelText} title={title}>
      <i className={`font-icon ${className} ${additionalClassName}`} />
    </div>
  );
}